import AboutUsCard from "./aboutUsCard";


function AboutUs(){

    return(
        <div>
        <section id="about-us" className="about-us">
          <h1>GenkaiX — Extend limits</h1>
          <h2>Master the skills, Drive the transformation</h2>
        </section>
        <section id="about-us-text" className="about-us-text">
          <h1 className="heading">Overview</h1>
          <div className="row">
            <div className="content">
              <h3>Why Choose Us?</h3>
              <p>Genkaix exists to help ambitious teams turn ideas into reliable digital products—websites, apps, and automations that launch fast and keep improving. The focus is simple: ship, learn, and iterate so results compound over time.<br />
                What started as a small crew frustrated with slow, siloed projects became a studio where strategy, design, and engineering work together from day one. That’s how deadlines are met, quality stays high, and outcomes are measurable—not just memorable</p>
              <h3>What We Do?</h3>
              <p>Websites and product UIs that are fast, accessible, and easy to update.<br />
                 Custom software and integrations that remove manual work and reduce risk.<br />
                 Cloud, data, and AI support to make systems scalable and insights useful.<br/>
                 Digital Marketing and Graphic design which elevate the user experience.<br/>
                 Learning Programs to upskill the knowledge and technological know hows.</p>
              {/* <a href="#"><button className="btn">About Us</button></a> */}
              <h3>Leadership</h3>
              <AboutUsCard/>
            </div>
          </div>
        </section>
      </div> 
    )
}
export default AboutUs;

//Genkaix exists to help ambitious teams turn ideas into reliable digital products—websites, apps, and automations that launch fast and keep improving. The focus is simple: ship, learn, and iterate so results compound over time.

//What started as a small crew frustrated with slow, siloed projects became a studio where strategy, design, and engineering work together from day one. That’s how deadlines are met, quality stays high, and outcomes are measurable—not just memorable
